module.exports = __webpack_public_path__ + "img/p61-conference.a16c2a61.jpg";